import { Controller, useFormContext } from "react-hook-form";

function CheckboxField({ name, label }) {
  const { control } = useFormContext();
  return (
    <div className="checkbox-with-label">
      <Controller
        name={name}
        control={control}
        rules={{}}
        render={({ field }) => (
          <input
            id={name}
            type="checkbox"
            checked={field.value}
            onChange={(e) => field.onChange(e.target.checked)}
          />
        )}
      />
      <label htmlFor={name} className="inline">
        {label}
      </label>
    </div>
  );
}

export default CheckboxField;
